import Acc from './page/acc.es6';
import Slider from './page/slider.es6';
import StickyButton from './page/sticky-button.es6';
import ZoomModal from './page/zoom-modal.es6';
import Scroll from './page/scroll.es6';

const acc = new Acc();
const slider = new Slider();
const stickyButton = new StickyButton();
const zoomModal = new ZoomModal();
const scroll = new Scroll();


async function Main() {
    acc.eventBind();
    acc.setHeight();
    scroll.setScrollReveal();
    scroll.setSmoothScroll();
    scroll.setScrollTrigger();
    window.addEventListener('resize', () => acc.initHeight());
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => Main());
} else {
    Main();
}
